export const NewListData = [
   {
    disputeId: "DSP-4001",
    id: 1,
    referenceNo: "REF-920301",
    customerName: "Aarav Sharma",
    accountNumber: "0123456789",
    branchName: "New Baneshwor",
    disputeType: "ATM Withdrawal Issue",
    transactionDate: "2025-11-01",
    createdDate: "2025-11-02",
    amount: 25000,
    status: "New",
    remarks: "Customer reported double debit issue",
    createdBy: "admin01",
  },
  {
    disputeId: "DSP-4002",
    id: 2,
    referenceNo: "REF-920302",
    customerName: "Sita Rai",
    accountNumber: "9876543210",
    branchName: "Kalimati",
    disputeType: "POS Transaction Failure",
    transactionDate: "2025-11-02",
    createdDate: "2025-11-03",
    amount: 8500,
    status: "New",
    remarks: "Customer charged but merchant not credited",
    createdBy: "officer02",
  },
  {
    disputeId: "DSP-4003",
    id: 3,
    referenceNo: "REF-920303",
    customerName: "Prakash Thapa",
    accountNumber: "5566778899",
    branchName: "Tripureshwor",
    disputeType: "Fund Transfer Delay",
    transactionDate: "2025-11-01",
    createdDate: "2025-11-02",
    amount: 15000,
    status: "New",
    remarks: "Transfer stuck between banks",
    createdBy: "officer01",
  },
  {
    disputeId: "DSP-4004",
    id: 4,
    referenceNo: "REF-920304",
    customerName: "Nisha Shrestha",
    accountNumber: "4455667788",
    branchName: "Jawalakhel",
    disputeType: "UPI Transaction Issue",
    transactionDate: "2025-11-03",
    createdDate: "2025-11-04",
    amount: 3000,
    status: "New",
    remarks: "Transaction failed but amount debited",
    createdBy: "admin02",
  },
  {
    disputeId: "DSP-4005",
    id: 5,
    referenceNo: "REF-920305",
    customerName: "Bibek Karki",
    accountNumber: "9988776655",
    branchName: "Thamel",
    disputeType: "Cheque Cleared Incorrectly",
    transactionDate: "2025-11-01",
    createdDate: "2025-11-02",
    amount: 50000,
    status: "New",
    remarks: "Wrong account credited",
    createdBy: "officer03",
  },
]